import React, {
  AnchorHTMLAttributes,
  MouseEvent,
  PropsWithChildren,
  createRef,
} from 'react';

import styles from '../styles.module.css';

export interface TabsTriggerProps
  extends PropsWithChildren<AnchorHTMLAttributes<HTMLAnchorElement>> {
  active?: boolean;
  onToggle: (hash: string) => void;
  keepActiveState?: boolean;
}

export const TabsTrigger: React.FC<TabsTriggerProps> = ({
  children,
  active = false,
  onToggle,
  keepActiveState = false,
  href,
  ...props
}) => {
  const anchorRef = createRef<HTMLAnchorElement>();

  function handleClick(e: MouseEvent<HTMLAnchorElement>) {
    e.preventDefault();
    onToggle(anchorRef.current!.hash);
  }

  const isActiveState = keepActiveState && active;

  return (
    <a
      href={href}
      className={`${styles.tabsTrigger} ${active ? styles.active : ''} ${
        isActiveState ? styles.keepActiveState : ''
      }`}
      onClick={handleClick}
      role="tab"
      ref={anchorRef}
      {...props}
    >
      {children}
    </a>
  );
};
